import './genericTooltip.css';

export const genericTooltip = {
  /**
   * Tooltip template
   * @param {string} id
   * @param {string} text
   * @param {string} classname
   * @param {boolean} absolute
   * @return {jQuery|HTMLElement}
   */
  tpl: ({id, text, classname = '', absolute = false}) => {
    const classnames = ['genericTooltip', classname, absolute ? 'is-absolute' : null].filter(v => v);
    return $(`<div class="${classnames.join(' ')}" data-tooltip-id="${id}"><span class="genericTooltip--children">${text}</span></div>`);
  },

  /**
   * Create tooltip
   * @param {jQuery|HTMLElement} $target - Element parent of the tooltip
   * @param {object} params
   * @param {string} params.id
   * @param {boolean} params.absolute - scoped in parent or body
   * @param {boolean} params.open - open by default
   */
  create: function ($target, params) {
    setTimeout(function () {
      if ($target.length && !$target.hasClass('tooltip-visible')) {
        $target.attr('data-tooltip-target-id', params.id);
        const $tooltip = genericTooltip.tpl(params);
        const isAbsolute = params.absolute || false;
        if (isAbsolute) {
          $('body').append($tooltip);
          genericTooltip.refreshPosition($target, params);
        } else {
          $target.append($tooltip);
        }

        if (params.open) {
          genericTooltip.open(params.id);
        }

        $(document).on('click', function () {
          /* Detect click outside tooltip */
          genericTooltip.close($target);
        });

        $(window).on('resize', function () {
          genericTooltip.refreshPosition($target, params);
        });
      }
    }, 50);
  },

  /**
   * Open tooltip
   * @param {string} id
   */
  open: function (id) {
    setTimeout(function () {
      const $target = $(`[data-tooltip-target-id=${id}]`);
      const $tooltip = $(`[data-tooltip-id=${id}]`);
      $target.addClass('tooltip-visible');
      $tooltip.addClass('visible');
    }, 100);
  },

  /**
   * Close tooltip
   * @param {jQuery|HTMLElement} $target
   */
  close: $target => {
    if ($target.length) {
      const id = $target.data('tooltip-target-id');
      $(`[data-tooltip-id=${id}]`).remove();
      $target.removeClass('tooltip-visible').removeAttr('data-tooltip-id');
    }
  },

  /**
   * Refresh position/offset of tooltip
   * @param {jQuery|HTMLElement} $target
   * @param {string} id
   * @param {boolean} absolute
   */
  refreshPosition: ($target, {id, absolute}) => {
    if (absolute) {
      const $tooltip = $(`[data-tooltip-id=${id}]`);
      $tooltip.css({
        top: $target.offset().top - $tooltip.outerHeight(),
        left: $target.offset().left + ($target.outerWidth(true) / 2)
      });
    }
  }
};